<template>
  <slot name="activator" :open="open" :close="close"></slot>

  <Teleport v-if="rootElement" :to="rootElement">
    <transition :name="transitionName">
      <div :class="[bemClass()]" v-show="isAlwaysActive || isActive" v-bind="$attrs">

        <div v-if="!isHeaderSlotEmpty" :class="bemClass('header')">
          <slot name="header" v-bind="headerSlotScope"></slot>
        </div>

        <sel-button v-if="isSlotEmpty('header') && !isAlwaysActive"
                    :class="bemClass('close')"
                    @click.prevent="close"
        >
          <slot name="close-icon">
            <sel-icon icon-name="arrow-back"></sel-icon>
          </slot>
        </sel-button>

        <slot :open="open" :close="close"></slot>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import activator from '../../compositions/activator'
import SelButton from '../sel-button/sel-button'
import SelIcon from '../sel-icon/sel-icon'
import useBem from '../../compositions/bem'
import useSlots from '../../compositions/slots'
import { computed, toRefs } from 'vue'

export default {
  name: 'SelPanel',
  inheritAttrs: false,
  components: { SelIcon, SelButton },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isAlwaysActive: {
      type: Boolean,
      default: false
    },
    rootElement: {
      type: [String, Object],
      default: null
    },
    activatorSelector: {
      type: String
    },
    transitionName: {
      type: String,
      default: 'slide-left'
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit, slots }) {
    const { isAlwaysActive, modifier } = toRefs(props)
    const { bemClass } = useBem('sel-panel', modifier)
    const { isSlotEmpty } = useSlots(slots)
    const { open, close } = activator(props, { emit })

    const isClosable = computed(() => !isAlwaysActive)
    const headerSlotScope = { close, isClosable }
    const isHeaderSlotEmpty = computed(() => isSlotEmpty('header', headerSlotScope))

    return {
      bemClass,
      isSlotEmpty,
      open,
      close,
      isHeaderSlotEmpty,
      headerSlotScope
    }
  }
}
</script>

<style scoped>
.sel-panel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
